import { adjustmentSessionIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const undoAdjustmentSession = {
  name: "undoAdjustmentSession" as const,
  input: z.object({ sessionId: adjustmentSessionIdFormat.schema }),
  output: z.object({ success: z.boolean(), pending: z.boolean().optional() }),
};
